module.exports = __webpack_public_path__ + "img/id.17b99676.svg";